import { render, staticRenderFns } from "./StockItemsTableCard.vue?vue&type=template&id=0e53447f&"
import script from "./StockItemsTableCard.vue?vue&type=script&lang=ts&"
export * from "./StockItemsTableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports